<template>
    <div class="col-mb-6 col-4 pdf-link">
        <a v-bind:href="pdfLink">
            <img
                class="pdf-link-img"
                alt=""
                v-bind:src="imageLink"/>
        </a >
        <br/>
        <span style="font-weight: bold;">
            TAXINUMMER {{nummer}}&nbsp;
            <br />
            {{date}}
        </span>
    </div>
</template>

<style>
.pdf-link{
    height: 230px;
    margin-bottom: 10px;
}
.pdf-link-img{
    max-width:129;
    max-height:179;
    display: block;
}
</style>

<script>
export default{
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    name: 'TaxinummerLink',
    props: ['nummer','date'],
    computed: {
        pdfLink(){
            return this.publicPath + "taxinummers/Taxinummer-" + this.nummer + ".pdf"
        },
        imageLink(){
            return this.publicPath +"images/cover-" + this.nummer + ".jpg"
        }
    }
}
</script>
